module.exports = __webpack_public_path__ + "static/step2_mission_dotted_wrapper_bg-67c57d939e6880784a1a6e484bd7c258.svg";